import type { Ref } from 'react';

export interface SummernoteRefContents {
  value: string;
  name?: string;
  type: 'text';
}

export enum RHFEventTypes {
  BLUR = 'blur',
  CHANGE = 'change',
}

export interface RHFCompatibleEvent {
  type: RHFEventTypes;
  target: SummernoteRefContents;
}

export interface SummernoteProps {
  innerRef?: Ref<SummernoteRefContents>;
  initialContents?: string;
  options?: Summernote.Options;
  name?: string;
  onChange?: (event: RHFCompatibleEvent) => Promise<void | boolean>;
  onBlur?: (event: RHFCompatibleEvent) => Promise<void | boolean>;
  onImageUpload?: (
    files: File[],
    insertImage: (url: string, filename?: string | Summernote.EditImageCallback) => void,
  ) => void;
  onMediaDelete?: (files: HTMLImageElement[]) => void;
  showLegacyCodeButton?: boolean;
}
